<template>
<div>
    <div class="form-group">
        <label class="col-xs-3 control-label" style="padding-top: 0;">
            <input type="text" :name="'company_item_name_' + freetext_index"
             :value="bind_model.item_name" @input="bind_model.item_name=$event.target.value" class="form-control" placeholder="項目名">
        </label>
        <div class="col-xs-8">
            <textarea :name="'company_item_contents_' + freetext_index"
             :value="bind_model.item_contents" @input="bind_model.item_contents=$event.target.value" class="form-control" rows="5" maxlength="1000" placeholder="内容を入力してください"></textarea>
            <p class="form_note m-t-sm m-b-none">1000文字まで</p>
        </div>
        <div class="col-xs-1">
            <button
            class="btn btn-primary btn-xs"
            type="button"
            @click="removeInput('#dialog_item_delete_'+ freetext_index)"
            >
                <i class="fa fa-trash"></i> 削除
            </button>
        </div>
    </div>
    <div
      class="modal fade inmodal"
      role="dialog"
      tabindex="-1"
      :id="'dialog_item_delete_' + freetext_index"
    >
      <app-item-delete
        :freetext_index="freetext_index"
        :freetext_array="freetext_array"
        :modal_id="'#dialog_item_delete_' + freetext_index"
      >
      </app-item-delete>
    </div>
    <hr class="hr-line-dashed">
</div>
</template>
<script>
export default {
  props: ["freetext_index", "freetext_array", "modal_id", "bind_model"],
  methods: {
      removeInput(modal_id) {
        $(modal_id).modal('show');
        },
    },
};
</script>
